const utils = {
  convertToBlob(documentFile) {
    const blob = this.getBlobConvertion(documentFile);

    let link = document.createElement('a');
    link.href = window.URL.createObjectURL(blob);
    link.download = documentFile.filename;
    link.click();
  },
  getBlobConvertion(documentFile) {
    const byteArray = this.convertToByteArray(documentFile.content);
    return new Blob([byteArray], {
      type: documentFile.contentType,
    });
  },
  convertToByteArray(documentContent) {
    const byteChars = atob(documentContent);
    const byteNumbers = new Array(byteChars.length);
    for (let i = 0; i < byteChars.length; i++) {
      byteNumbers[i] = byteChars.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);

    return byteArray;
  },
  formatString(template, ...args) {
    return template.replace(/{(\d+)}/g, (match, index) =>
      args[index] !== undefined ? args[index] : match
    );
  },
};

export default utils;
